/* unplugin-vue-components disabled */import { render } from "./PriceCalculateQuestionEditor.vue?vue&type=template&id=a8a74f4e&scoped=true"
import script from "./PriceCalculateQuestionEditor.vue?vue&type=script&lang=js"
export * from "./PriceCalculateQuestionEditor.vue?vue&type=script&lang=js"

import "./PriceCalculateQuestionEditor.vue?vue&type=style&index=0&id=a8a74f4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a74f4e"]])

export default __exports__